import React, { useState, useEffect, useMemo, useCallback } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "../../../../utils/notifications";
import ReactDropdown from "react-dropdown";
import "react-dropdown/style.css";
import KiemKeApi from "service/BaoCao/KiemKeApi";
import CashApi from "service/thuchiApi";
import UserApi from "service/userApi";
import { format } from "date-fns";
import { getDate } from "../../../../utils/formatDate";
import { MENH_GIA } from "../../../../utils/kiemkeUtils";
import { formatNumber2 } from "../../../../utils/currencyFormat"
import NumberFormat from 'react-number-format';

const initFormData = {
    KiemKeId: 0,
    LoaiKiemKe: "Cuối ngày",
    Time: format(new Date(), 'dd-MM-yyyy HH:mm:ss'),
    NguoiKiemKe: "",
    GhiChu: "",
    QuyTienMat: 0,
    TotalKiemKe: 0,
    ChiTiet: []
};

export const ModalThemMoi = ({ show, onHide, item, onSaved }) => {
    const [formData, setFormData] = useState(initFormData);
    const [nganHangs, setNganHangs] = useState([]);
    const [cashDenominations, setCashDenominations] = useState(MENH_GIA.map(() => 0));
    const [systemCash, setSystemCash] = useState(0);
    const [userCombo, setUserCombo] = useState([]);
    const [isSubmit, setIsSubmit] = useState(false);
    const [errors, setErrors] = useState({});

    const loaiKiemKeOptions = [
        { value: "Đầu ngày", label: "Đầu ngày" },
        { value: "Cuối ngày", label: "Cuối ngày" }
    ];

    const loadUserCombo = useCallback(async () => {
        try {
            const userRes = await UserApi.combo2();
            if (userRes && userRes.status === 200) {
                setUserCombo(userRes.data || []);
            }
        } catch (e) {
            console.error("Lỗi khi tải user combo:", e);
        }
    }, []);

    const fetchLiveSystemCash = useCallback(async () => {
        try {
            const cashRes = await CashApi.getList();
            if (cashRes && cashRes.status === 200) {
                setSystemCash(cashRes.data || 0);
            }
        } catch (e) {
            console.error("Lỗi khi tải quỹ tiền mặt:", e);
        }
    }, []);

    useEffect(() => {
        if (show) {
            loadUserCombo();
            setErrors({});
            if (item && item.KiemKeId > 0) {
                setFormData(item);
                setSystemCash(item.QuyTienMat || 0);
                const banks = item.ChiTiet?.filter(c => c.LoaiTienTe === true) || [];
                const cash = item.ChiTiet?.filter(c => c.LoaiTienTe === false) || [];
                setNganHangs(banks.map(b => ({ MenhGia: b.MenhGia, SoLuong: b.SoLuong })));
                const cashState = MENH_GIA.map(m => {
                    const found = cash.find(c => c.MenhGia === m.label);
                    return found ? found.SoLuong : 0;
                });
                setCashDenominations(cashState);
            } else {
                setFormData({ ...initFormData });
                setNganHangs([]);
                setCashDenominations(MENH_GIA.map(() => 0));
                fetchLiveSystemCash();
            }
        }
    }, [show, item, loadUserCombo, fetchLiveSystemCash]);


    const { tongTienMat, tongTienNganHang, tongCong, chenhLech } = useMemo(() => {
        const ttMat = cashDenominations.reduce((sum, sl, idx) => sum + (Number(sl) || 0) * MENH_GIA[idx].value, 0);
        const ttNH = nganHangs.reduce((sum, n) => sum + (Number(n.SoLuong) || 0), 0);
        const ttCong = ttMat + ttNH;
        const cl = ttCong - systemCash;
        return { tongTienMat: ttMat, tongTienNganHang: ttNH, tongCong: ttCong, chenhLech: cl };
    }, [cashDenominations, nganHangs, systemCash]);

    const displayedUserValue = useMemo(() => {
        const { NguoiKiemKe } = formData;
        if (!NguoiKiemKe) return undefined;
        return userCombo.find(opt => opt.label === NguoiKiemKe) || { label: NguoiKiemKe, value: NguoiKiemKe };
    }, [formData, userCombo]);

    const handleFormChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
        if (errors[field]) setErrors(prev => ({ ...prev, [field]: "" }));
    };

    const handleAddNganHang = () => setNganHangs([...nganHangs, { MenhGia: "", SoLuong: 0 }]);
    const handleRemoveNganHang = (index) => {
        const list = [...nganHangs];
        list.splice(index, 1);
        setNganHangs(list);
    };
    const handleChangeNganHang = (index, field, value) => {
        const list = [...nganHangs];
        list[index][field] = field === "SoLuong" ? (value.floatValue || 0) : value;
        setNganHangs(list);
    };
    const handleChangeSoLuongTien = (index, value) => {
        const list = [...cashDenominations];
        list[index] = value.floatValue || 0;
        setCashDenominations(list);
    };

    const validateForm = () => {
        let valid = true;
        let err = {};
        if (!formData.NguoiKiemKe) {
            err.nguoiKiemKe = "Vui lòng chọn người kiểm kê!";
            valid = false;
        }
        if (chenhLech !== 0 && !formData.GhiChu?.trim()) {
            err.ghiChu = "Phát hiện chênh lệch, vui lòng nhập lý do!";
            valid = false;
        }
        if (nganHangs.some(b => b.SoLuong > 0 && !b.MenhGia.trim())) {
            err.nganHang = "Tên ngân hàng không được để trống nếu số tiền > 0.";
            valid = false;
        }
        setErrors(err);
        return valid;
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        setIsSubmit(true);
        const chiTietCash = MENH_GIA.map((m, idx) => ({ MenhGia: m.label, SoLuong: cashDenominations[idx] || 0, LoaiTienTe: false }));
        const chiTietBanks = nganHangs.filter(b => b.MenhGia.trim() !== "" || b.SoLuong > 0).map(b => ({ MenhGia: b.MenhGia, SoLuong: b.SoLuong || 0, LoaiTienTe: true }));
        const payload = { ...formData, QuyTienMat: systemCash, TotalKiemKe: tongCong, ChiTiet: [...chiTietBanks, ...chiTietCash] };
        
        try {
            const res = payload.KiemKeId > 0 ? await KiemKeApi.updateKiemKe(payload) : await KiemKeApi.addKiemKe(payload);
            if (res.status === 200) {
                pushNotification("Thao tác thành công!", "success", "TOP_CENTER", 2000);
                if (onSaved) onSaved();
            } else {
                pushNotification(res.message || "Thao tác thất bại!", "error", "TOP_CENTER", 2000);
            }
        } catch (error) {
            pushNotification(error.message || "Có lỗi xảy ra!", "error", "TOP_CENTER", 2000);
        }
        setIsSubmit(false);
    };

    return (
        <Modal show={show} onHide={onHide} size="xl" centered className="modal-new modal fade text-left" backdrop="static">
            <Modal.Header>
                <h4 className="modal-title color7-bold">
                    <span className="btn-icon-right">
                        <img src={formData.KiemKeId > 0 ? "/app-assets/images/icon-editphieuthuchi.png" : "/app-assets/images/icon-tao-moi-don-nhap-hang.png"} alt="icon" />
                    </span>
                    {formData.KiemKeId > 0 ? "Cập nhật Phiếu Kiểm Kê" : "Thêm mới Phiếu Kiểm Kê"}
                </h4>
                <button type="button" className="close-popup-new" onClick={onHide} disabled={isSubmit}>
                    <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                </button>
            </Modal.Header>

            <form onSubmit={handleFormSubmit}>
                <Modal.Body style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                    <div className="form form-horizontal">
                        <div className="form-body">
                            <div className="row">
                                <div className="col-12 col-md-4 ">
                                    <div className="form-group">
                                        <label className="label-control color7-bold mb-1">Loại kiểm kê</label>
                                        <ReactDropdown
                                            options={loaiKiemKeOptions}
                                            onChange={(opt) => handleFormChange("LoaiKiemKe", opt.value)}
                                            value={loaiKiemKeOptions.find(opt => opt.value === formData.LoaiKiemKe)}
                                            controlClassName="form-control input-sm"
                                            placeholder="Chọn loại"
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 ">
                                    <div className="form-group">
                                        <label className="label-control color7-bold mb-1">Ngày kiểm kê</label>
                                        <input 
                                            type="text" 
                                            className="form-control input-sm" 
                                            value={getDate(formData.Time)} 
                                            readOnly 
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 ">
                                    <div className="form-group">
                                        <label className="label-control color7-bold mb-1">Người kiểm kê <span className="canh-bao-red">*</span></label>
                                        <ReactDropdown
                                            options={userCombo}
                                            onChange={(opt) => handleFormChange("NguoiKiemKe", opt.label)}
                                            value={displayedUserValue}
                                            placeholder="Chọn người kiểm kê"
                                            controlClassName={`form-control input-sm ${errors.nguoiKiemKe ? 'is-invalid' : ''}`}
                                        />
                                        <span className="canh-bao-red">{errors.nguoiKiemKe}</span>
                                    </div>
                                </div>
                            </div>

                            <hr />

                            {/* I. Dòng tiền hệ thống */}
                            <div className="row mb-3">
                                <div className="col-12">
                                    <strong className="label-control color7-bold" style={{ fontSize: '15px' }}>
                                        I. Dòng tiền trong hệ thống: 
                                        <span style={{ color: 'red', marginLeft: '10px', fontSize: '16px' }}>{formatNumber2(systemCash)}</span>
                                    </strong>
                                </div>
                            </div>

                            {/* II. Tiền gửi ngân hàng*/}
                            <div className="row mb-3">
                                <div className="col-12">
                                    <strong className="label-control color7-bold d-block mb-2">II. Kiểm kê tiền gửi ngân hàng</strong>
                                        <div className="table-mobile table-mobile-hover">
                                            <div className="custom-table-wrapper" style={{ overflowX: "auto", maxHeight: 250, overflowY: 'auto' }}>
                                                <div className="table-headers">
                                                    <div className="custom-table-header text-left" style={{ flexBasis: '50%', justifyContent: 'flex-start' }}>
                                                        <p>Tên ngân hàng / Ví</p>
                                                    </div>
                                                    <div className="custom-table-header text-right" style={{ flexBasis: '40%', justifyContent: 'flex-end' }}>
                                                        <p>Số tiền</p>
                                                    </div>
                                                    <div className="custom-table-header text-center" style={{ flexBasis: '10%', justifyContent: 'center' }}>
                                                        <p>Xóa</p>
                                                    </div>
                                                </div>
                                                <div className="custom-table-body">
                                                    {nganHangs.map((n, idx) => (
                                                        <div className="custom-table-row" key={idx} style={{ minHeight: '56px' }}>
                                                            <div className="custom-table-cell" style={{ flexBasis: '50%', justifyContent: 'flex-start' }}>
                                                                <span className="mobile-column-name color7-bold">Tên ngân hàng / Ví</span>
                                                                <div className="center-wrapper" style={{ width: '100%' }}>
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control input-sm" 
                                                                        value={n.MenhGia} 
                                                                        onChange={(e) => handleChangeNganHang(idx, "MenhGia", e.target.value)} 
                                                                        placeholder="Tên ngân hàng..." 
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="custom-table-cell" style={{ flexBasis: '40%', justifyContent: 'flex-end' }}>
                                                                <span className="mobile-column-name color7-bold">Số tiền</span>
                                                                <div className="center-wrapper" style={{ width: '100%' }}>
                                                                    <NumberFormat 
                                                                        className="form-control input-sm text-right" 
                                                                        value={n.SoLuong} 
                                                                        thousandSeparator="," decimalSeparator="." 
                                                                        onValueChange={(values) => handleChangeNganHang(idx, "SoLuong", values)} 
                                                                        allowNegative={false} 
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="custom-table-cell" style={{ flexBasis: '10%', justifyContent: 'center' }}>
                                                                <span className="mobile-column-name color7-bold">Xóa</span>
                                                                <div className="center-wrapper">
                                                                    <button type="button" className="btn btn-danger btn-sm" onClick={() => handleRemoveNganHang(idx)}>X</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <button type="button" className="btn btn-success btn-sm mt-2 ml-1" onClick={handleAddNganHang}>+ Thêm ngân hàng</button>
                                    <span className="canh-bao-red d-block">{errors.nganHang}</span>
                            </div>

                            {/* III. Kiểm kê tiền mặt */}
                            <div className="row mb-3">
                                <div className="col-12">
                                    <strong className="label-control color7-bold d-block mb-2">III. Kiểm kê tiền mặt</strong>
                                    <div className="Left808x200 Table-main-new css-table-ds">
                                        <div className="table-mobile table-mobile-hover">
                                            <div className="custom-table-wrapper" >
                                                <div className="table-headers">
                                                    <div className="custom-table-header text-left" style={{ flexBasis: '30%', justifyContent: 'flex-start' }}>
                                                        <p>Mệnh giá</p>
                                                    </div>
                                                    <div className="custom-table-header text-right" style={{ flexBasis: '30%', justifyContent: 'flex-end' }}>
                                                        <p>Số lượng (tờ)</p>
                                                    </div>
                                                    <div className="custom-table-header text-right" style={{ flexBasis: '40%', justifyContent: 'flex-end' }}>
                                                        <p>Thành tiền</p>
                                                    </div>
                                                </div>
                                                <div className="custom-table-body">
                                                    {MENH_GIA.map((m, idx) => (
                                                        <div className="custom-table-row" key={m.value} style={{ minHeight: '56px' }}>
                                                            <div className="custom-table-cell" style={{ flexBasis: '30%', justifyContent: 'flex-start' }}>
                                                                <span className="mobile-column-name color7-bold">Mệnh giá</span>
                                                                <div className="center-wrapper">
                                                                    <p className="m-0 pl-2 font-weight-bold">{m.label}</p>
                                                                </div>
                                                            </div>
                                                            <div className="custom-table-cell" style={{ flexBasis: '30%', justifyContent: 'flex-end' }}>
                                                                <span className="mobile-column-name color7-bold">Số lượng (tờ)</span>
                                                                <div className="center-wrapper" style={{ width: '100%' }}>
                                                                    <NumberFormat 
                                                                        className="form-control input-sm text-right" 
                                                                        value={cashDenominations[idx]} 
                                                                        thousandSeparator="," decimalSeparator="." 
                                                                        onValueChange={(values) => handleChangeSoLuongTien(idx, values)} 
                                                                        allowNegative={false} allowLeadingZeros={false} 
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="custom-table-cell" style={{ flexBasis: '40%', justifyContent: 'flex-end' }}>
                                                                <span className="mobile-column-name color7-bold">Thành tiền</span>
                                                                <div className="center-wrapper text-right">
                                                                    <p className="m-0 font-weight-bold color-xanh">{formatNumber2((cashDenominations[idx] || 0) * m.value)}</p>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ backgroundColor: '#f5f7fa', padding: '15px', borderRadius: '5px', margin: '0' }}>
                                <div className="col-12 col-md-6 border-right-md mb-3 mb-md-0">
                                    <div className="d-flex justify-content-between mb-2">
                                        <label className="label-control color7-bold mb-0">Tổng tiền NH (II):</label>
                                        <strong>{formatNumber2(tongTienNganHang)}</strong>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <label className="label-control color7-bold mb-0">Tổng tiền mặt (III):</label>
                                        <strong>{formatNumber2(tongTienMat)}</strong>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="d-flex justify-content-between mb-2">
                                        <label className="label-control color7-bold mb-0">TỔNG CỘNG (II + III):</label>
                                        <strong style={{ color: 'blue', fontSize: '16px' }}>{formatNumber2(tongCong)}</strong>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <label className="label-control color7-bold mb-0">CHÊNH LỆCH:</label>
                                        <strong style={{ color: 'red', fontSize: '16px' }}>{formatNumber2(chenhLech)}</strong>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12">
                                    <label className="label-control color7-bold mb-1">
                                        Ghi chú / Lý do chênh lệch {chenhLech !== 0 && <span className="canh-bao-red">*</span>}
                                    </label>
                                    <textarea
                                        className={`form-control1 input-sm ${errors.ghiChu ? 'is-invalid' : ''}`}
                                        rows={3}
                                        style={{width: "100%"}}
                                        value={formData.GhiChu}
                                        onChange={(e) => handleFormChange("GhiChu", e.target.value)}
                                        placeholder="Nhập lý do nếu có chênh lệch..."
                                    ></textarea>
                                    <span className="canh-bao-red">{errors.ghiChu}</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button type="button" className="btn btn-new-main btn-closenew" onClick={onHide} disabled={isSubmit}>
                        <i className="mdi mdi-close"></i>&nbsp; Đóng
                    </button>
                    <button type="submit" className="btn btn-new-main button-popup-submit" disabled={isSubmit}>
                        <img src="/app-assets/images/icon-send-v2.png" alt="save" />&nbsp; {isSubmit ? "Đang lưu..." : (formData.KiemKeId > 0 ? "Lưu thay đổi" : "Tạo phiếu")}
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};